import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IIMunicipalitiesResponse,
  IMlsContract,
  IMunicipalityDetail,
  IMunicipalityDetailUpdate,
  IPermitValuationMethod
} from '../models';
import { ISchoolDistrict } from './../models/municipalities';

export const getMunicipalities = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  isActive?: boolean;
}): Promise<IIMunicipalitiesResponse> => {
  try {
    const { data } = await axios.get(`/api/municipalities`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getMunicipalities failed');
    return Promise.reject(error);
  }
};

export const createMunicipality = async (post: IMunicipalityDetailUpdate): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/municipalities`, post);
    return data;
  } catch (error) {
    logError({ error, payload: post }, 'createMunicipality failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getMunicipality = async (id: number): Promise<IMunicipalityDetail> => {
  try {
    const { data } = await axios.get(`/api/municipalities/${id}`);
    return data;
  } catch (error) {
    logError({ error, id }, 'getMunicipality failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateMunicipality = async (id, post: IMunicipalityDetailUpdate): Promise<any[]> => {
  try {
    const { data } = await axios.put(`/api/municipalities/${id}`, post);
    return data;
  } catch (error) {
    logError({ error, payload: post }, 'updateMunicipality failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getMunicipalityMlsContracts = async (): Promise<IMlsContract[]> => {
  try {
    const { data } = await axios.get('/api/municipalities/mls-contracts');
    return data;
  } catch (error) {
    logError(error, 'getMunicipalityMlsContracts failed');
    return Promise.reject(error);
  }
};

export const getMunicipalityPermitValuationMethods = async (): Promise<
  IPermitValuationMethod[]
> => {
  try {
    const { data } = await axios.get('/api/municipalities/permit-valuation-methods');
    return data;
  } catch (error) {
    logError(error, 'getMunicipalityPermitValuationMethods failed');
    return Promise.reject(error);
  }
};

export const getMuniciplaitySchoolDistricts = async (
  municipalityId: number | string
): Promise<ISchoolDistrict[]> => {
  try {
    const { data } = await axios.get(`/api/municipalities/${municipalityId}/school-districts`);
    return data;
  } catch (error) {
    logError(error, 'getMuniciplaitySchoolDistricts failed');
    return Promise.reject(error);
  }
};
